import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { linksOf } from "../../services/cpln";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { VolumeSet } from "../../schema/types/volumeSet/entity";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpTextArea } from "../gvc/testNewForm/CpTextArea";
import { CpLabelDirtyIndicator } from "../gvc/testNewForm/CpLabelDirtyIndicator";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { FormItem } from "../../components/antd/form/FormItem";
import { FormItemValue } from "../../components/antd/form/FormItemValue";
import { parseLink } from "../../utils/linkParser/linkParser";

interface Props {
  volumeSet: VolumeSet;
}
export const Summary: React.FC<Props> = ({ volumeSet }) => {
  const selfLink = linksOf(volumeSet).self!;
  const gvcName = parseLink(selfLink, { useInputCtx: true }).gvc;

  const hasTagLinks = React.useMemo(() => {
    return (
      Object.entries(volumeSet.tags || {}).filter(([_, value]) =>
        tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)),
      ).length > 0
    );
  }, [volumeSet.version]);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`description`}>
                <FormLabel>Description</FormLabel>
                <CpLabelDirtyIndicator name={`description`} />
              </CpLabel>
              <CpTextArea autoSize name={`description`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`description`} />
            </CpFormItem>
            <FormItem>
              <FormLabel>GVC</FormLabel>
              <FormItemValue>{gvcName}</FormItemValue>
            </FormItem>
            {hasTagLinks ? (
              <TagLinksTable
                tableId="volumeset-info-tag-links"
                tags={Object.entries(volumeSet.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
